import { css } from 'styled-components';
export const NoWordWrap = css `
  overflow-wrap: normal;
  word-wrap: normal;
  hyphens: none;
`;
